<div class="w-screen h-screen flex flex-col">
  <app-header></app-header>
  <app-topbar></app-topbar>
  <div class="relative flex-1">
    <app-viewport></app-viewport>
  </div>
</div>